import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getOrderMSServiceDocumentListData } from './mockData'
import type { IOrderMSServiceDocument } from '~/types/document/models'

export const {
  getDocuments: getOrderMSServiceDocuments,
  postDocument: postOrderMSServiceDocument,
  patchDocument: patchOrderMSServiceDocument,
  deleteDocument: deleteOrderMSServiceDocument,
  handlers,
} = makeDocumentAPIs<IOrderMSServiceDocument>({
  apiPathEntityNamePrefix: 'ordermsservice',
  getDocumentListDataFn: getOrderMSServiceDocumentListData,
})
